class OnboardingService {
  constructor() {
    this.baseURL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
  }

  async checkForDefaultKey(jwt) {
    if (!jwt) throw new Error('JWT token required');

    try {
      const response = await fetch(`${this.baseURL}/admin/m2m/clients`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${jwt}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const data = await response.json();
      const clients = data.clients || [];

      const defaultKey = clients.find(c =>
        c.client_name === 'Default' ||
        c.client_description === 'Created at onboarding'
      );

      return defaultKey ? { exists: true, clientId: defaultKey.client_id } : { exists: false };
    } catch (error) {
      console.error('Failed to check for default key:', error);
      return { exists: false };
    }
  }

  async createDefaultKey(jwt) {
    if (!jwt) throw new Error('JWT token required');

    try {
      const response = await fetch(`${this.baseURL}/admin/m2m/clients`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${jwt}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          client_name: 'Default',
          client_description: 'Created at onboarding'
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const data = await response.json();

      return {
        clientId: data.client_id,
        clientSecret: data.client_secret,
        fullKey: `${data.client_id}:${data.client_secret}`
      };
    } catch (error) {
      console.error('Failed to create default key:', error);
      throw error;
    }
  }

}

export default new OnboardingService();
